/* eslint-disable */
import React from 'react'
import {accounting} from 'accounting'
import {divIcon} from 'leaflet'
import {renderToStaticMarkup} from 'react-dom/server'
import {Map, Marker, TileLayer, Popup} from 'react-leaflet'
import http from '../../Component/Interceptor/Interseptor'
import {Icon, message} from 'antd'
import {Link} from 'react-router-dom'
import Select from 'react-select'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import RETAIL from '../BaseComponent/RETAIL'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import jMoment from 'moment-jalaali'
import moment from 'moment'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'

// const MapWithAMarker = withScriptjs(withGoogleMap(props =>
//     <GoogleMap
//         defaultZoom={10}
//         defaultCenter={{ lat: 35.74287570972717, lng: 51.54944953647805 }}
//     >
//         {props.points.map((markers,index)=>(
//             <Marker
//                 key={index}
//                 icon={markers.checked == false ? require('../../image/requestPack.png') : require('../../image/finishPack.png')}
//                 position={{lat: markers.latitude, lng: markers.longitude}}
//                 title={markers.buyerName+'- شماره فاکتور : '+markers.invoiceNum}
//                 checked={markers.checked}
//                 geoTitle={markers.geo.title}
//                 deliveryPackId={markers.deliveryPackId}
//                 invoiceId={markers.invoiceId}
//                 invoiceNum={markers.invoiceNum}
//                 totalAmount={markers.totalAmount}
//                 payableAmount={markers.payableAmount}
//                 Address={markers.address}
//                 buyerName={markers.buyerName}
//                 checked={!(markers.checked)}
//                 onClick={()=>props.onMarkerClick(index,markers.deliveryPackId,markers.invoiceId,markers.invoiceNum,markers.totalAmount,markers.payableAmount,markers.address,markers.geoTitle,markers.buyerName,true)} />
//         ))}

//     </GoogleMap>
// ));

class Returned extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      points: [],
      custommer: [],
      drivers: [],
      cars: [],
      openTable: false,
      packId: [],
      assignError: '',
      tarh: 'all',
      withOutMarker: [],
      masterPoints: [],
      oddCars: [],
      evenCars: [],
      data: [],
      latCenter: 35.74287570972717,
      lonCenter: 51.54944953647805,
      driverCarId: '',
      listGeo: [],
      actionText: '',
      showForm: false,
      selectedDateFrom: moment(),
      planOption: [],
      now: moment()
    }
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  epochFrom = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochTo = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  handleChangeplanOption = (planOption) => {
    this.setState({planOption})
  }

  handleMarkerClick = (
    index,
    deliveryPackId,
    invoiceId,
    invoiceNum,
    totalAmount,
    payableAmount,
    Address,
    geoTitle,
    buyerName,
    markerChecked
  ) => {
    let positionObject = {
      deliveryPackId: deliveryPackId,
      invoiceId: invoiceId,
      invoiceNum: invoiceNum,
      totalAmount: totalAmount,
      payableAmount: payableAmount,
      address: Address,
      geo: {
        title: geoTitle
      },
      buyerName: buyerName,
      checked: markerChecked
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[index].checked = positionObject.checked
      return {
        points: newpoints
      }
    })
    const isFound = this.state.custommer.find((custommer) => custommer.deliveryPackId === positionObject.deliveryPackId)
    if (!isFound) {
      this.setState((prevState) => ({
        custommer: [...prevState.custommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  getPlanForReturnPlan = (myDate, onloadPage) => {
    var date = this.convertDigit(jMoment(myDate).format('jYYYY/jMM/jDD'))
    var dataPlan = {
      from: this.epochFrom(date),
      to: this.epochTo(date)
    }
    http
      .get(`report/dispatch/plan/all?planDateMin=${dataPlan.from}&planDateMax=${dataPlan.to}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var result = response.data.object.result
          for (let i = 0; i < result.length; i++) {
            result[i]['value'] = result[i].planId
            result[i]['label'] =
              result[i].planTimeFrom +
              '-' +
              result[i].planTimeTo +
              '-' +
              jMoment(result[i].planDate).format('jYYYY/jMM/jDD')
          }

          this.setState({
            allPlans: response.data.object.result,
            showSelectBox: true
          })
        } else {
          if (onloadPage) {
          } else {
            message.error(response.data.description)
          }
          this.setState({
            allPlans: []
          })
        }
      })
      .catch((error) => {
        console.log(error)
      })
  }

  componentDidMount() {
    // alert(this.state.selectedDateFrom)
    this.getPlanForReturnPlan(this.state.selectedDateFrom, true)

    http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_GEO}?type=3`, {}).then((response) => {
      if (response.data.error == null) {
        this.setState({
          listGeo: response.data.object
        })
      } else {
        this.setState({
          listGeo: ''
        })
      }
    })

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_RETURNED_ALL}?export=true&sortBy=geoTitle_ASC`, {})
      .then((response) => {
        if (response.data.error == null) {
          var points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }
          this.setState({
            points: response.data.object.result,
            masterPoints: response.data.object.result
          })

          var withOutPointArr = []

          for (let j = 0; j < points.length; j++) {
            if (this.state.points[j]['latitude'] == null) {
              withOutPointArr.push(this.state.points[j])
            }
          }
          this.setState({
            withOutMarker: withOutPointArr
          })
        } else if (response.data.error == 'EMPTY_RESULTS') {
          message.error('در این محدوده زمانی سفارشی موجود نیست')
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          this.setState({
            drivers: response.data.object
          })
        } else {
          alert(JSON.stringify(response.data))
        }
        // alert(JSON.stringify(response.data))
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
        console.log(error)
      })
  }

  handleDateChangeFrom = (date) => {
    this.setState({selectedDateFrom: date})
    this.getPlanForReturnPlan(date, false)
  }

  fromDate(props) {
    return <input className="form-control" {...props} />
  }

  removeCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.points[id].deliveryPackId,
      invoiceId: this.state.points[id].invoiceId,
      invoiceNum: this.state.points[id].invoiceNum,
      totalAmount: this.state.points[id].totalAmount,
      geo: {
        title: this.state.points[id].geo.title
      },
      payableAmount: this.state.points[id].payableAmount,
      address: this.state.points[id].address,
      buyerName: this.state.points[id].buyerName,
      checked: false
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[id].checked = positionObject.checked
      return {
        points: newpoints
      }
    })

    var index = this.state.custommer.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)
    this.state.custommer.splice(index, 1)
    this.setState(this.state.custommer)
    if (this.state.custommer.length == '0') {
      this.setState({
        openTable: false
      })
    }
  }

  addCustomer = (rowId) => {
    let id = rowId.index
    const positionObject = {
      deliveryPackId: this.state.points[id].deliveryPackId,
      invoiceId: this.state.points[id].invoiceId,
      invoiceNum: this.state.points[id].invoiceNum,
      detailId: this.state.points[id].detailId,
      totalAmount: this.state.points[id].totalAmount,
      geo: {
        title: this.state.points[id].geo.title
      },
      payableAmount: this.state.points[id].payableAmount,
      address: this.state.points[id].address,
      buyerName: this.state.points[id].buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[id].checked = positionObject.checked
      return {
        points: newpoints
      }
    })

    const isFound = this.state.custommer.find((custommer) => custommer.deliveryPackId === positionObject.deliveryPackId)
    if (!isFound) {
      this.setState((prevState) => ({
        custommer: [...prevState.custommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  delete = (rowId) => {
    const positionObject = {
      deliveryPackId: this.state.custommer[rowId].deliveryPackId,
      invoiceId: this.state.custommer[rowId].invoiceId,
      invoiceNum: this.state.custommer[rowId].invoiceNum,
      totalAmount: this.state.custommer[rowId].totalAmount,
      payableAmount: this.state.custommer[rowId].payableAmount,
      address: this.state.custommer[rowId].address,
      buyerName: this.state.custommer[rowId].buyerName,
      checked: false
    }

    var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)
    if (index >= 0) {
      this.setState((prevState) => {
        let newpoints = this.state.points
        // alert(JSON.stringify(newpoints[index]))
        newpoints[index].checked = positionObject.checked
        return {
          points: newpoints
        }
      })
    } else {
    }

    this.state.custommer.splice(rowId, 1)
    this.setState(this.state.custommer)

    if (this.state.custommer.length == '0') {
      this.setState({
        openTable: false
      })
    }
  }

  deleteAllCustomer() {
    let points = this.state.points
    for (let i = 0; i < points.length; i++) {
      this.setState((prevState) => {
        let newpoints = points
        newpoints[i].checked = false
        return {
          points: newpoints
        }
      })
    }

    this.setState({
      custommer: [],
      openTable: false
    })
  }

  Up = (rowId) => {
    if (rowId > 0) {
      let temp = this.state.custommer[rowId - 1]
      this.state.custommer[rowId - 1] = this.state.custommer[rowId]
      this.state.custommer[rowId] = temp
      this.setState(this.state.custommer)
    }
  }
  Down = (rowId) => {
    if (rowId < this.state.custommer.length - 1) {
      let temp = this.state.custommer[rowId + 1]
      this.state.custommer[rowId + 1] = this.state.custommer[rowId]
      this.state.custommer[rowId] = temp
      this.setState(this.state.custommer)
    }
  }

  Sort() {
    let {custommer} = this.state
    const token = sessionStorage.getItem('accessToken')

    for (var a = 0; a < custommer.length; a++) {
      this.state.packId.push(custommer[a]['deliveryPackId'])
    }
    var sortData = {
      deliveryPackIds: this.state.packId
    }

    http
      .post(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_SORT}`, sortData, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then((response) => {
        if (response.data.error == null) {
          this.setState({
            custommer: response.data.object.result
          })
        } else if (response.data.error == 'EMPTY_RESULTS') {
          message.error('سفارشی ارسال نشده است')
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }

  submit(e) {
    e.preventDefault()
  }

  changeAction(e) {
    let target = e.target
    this.setState({
      actionText: target.options[target.selectedIndex].text
    })
    if (target.options[target.selectedIndex].text == '------') {
      this.setState({
        showForm: false
      })
    } else if (target.options[target.selectedIndex].text == 'مرجوع') {
      this.setState({
        showForm: false
      })
    } else if (target.options[target.selectedIndex].text == 'تخصیص مجدد') {
      this.setState({
        showForm: true
      })
    }
  }

  action() {
    let {custommer, showForm, planOption} = this.state
    var planId = planOption.length == '0' ? '' : planOption.planId
    let cartype = document.getElementById('carType').value
    let driver = document.getElementById('driver').value
    let planDate = this.convertDigit(document.getElementById('planDate').value)

    let action = document.getElementById('action').value
    if (action == '') {
      this.setState({
        assignError: 'عملیات مورد نظر را انتخاب کنید'
      })
    } else if (driver == '' && showForm) {
      this.setState({
        assignError: 'رساننده را انتخاب کنید'
      })
    } else if (cartype == '' && showForm) {
      this.setState({
        assignError: 'اتومبیل را انتخاب کنید'
      })
    } else if (planDate == '' && showForm) {
      this.setState({
        assignError: 'تاریخ را انتخاب کنید'
      })
    } else if (planId == '' && showForm) {
      this.setState({
        assignError: 'پلن را انتخاب کنید'
      })
    } else {
      for (var a = 0; a < custommer.length; a++) {
        this.state.packId.push(custommer[a]['detailId'])
      }

      if (action == 'marju') {
        var data = {
          dispatchDetailIds: this.state.packId
        }
        http
          .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_REJECT}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              message.success('عملیات با موفقیت انجام شد')
              this.setState({
                custommer: [],
                openTable: false,
                packId: []
              })
              http
                .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_RETURNED_ALL}?export=true&sortBy=geoTitle_ASC`, {})
                .then((response) => {
                  if (response.data.error == null) {
                    var points = response.data.object.result
                    for (let i = 0; i < points.length; i++) {
                      points[i]['checked'] = false
                      points[i]['geoTitle'] = points[i]['geo'].title
                    }
                    this.setState({
                      points: response.data.object.result,
                      masterPoints: response.data.object.result
                    })

                    var withOutPointArr = []

                    for (let j = 0; j < points.length; j++) {
                      if (this.state.points[j]['latitude'] == null) {
                        withOutPointArr.push(this.state.points[j])
                      }
                    }
                    this.setState({
                      withOutMarker: withOutPointArr
                    })
                  } else if (response.data.error == 'EMPTY_RESULTS') {
                    message.error('در این محدوده زمانی سفارشی موجود نیست')
                  }
                })
                .catch((error) => {
                  alert(JSON.stringify(error))
                })
            } else {
              this.setState({
                packId: []
              })
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      } else if (action == 'reAssign') {
        var data = {
          dispatchDetailIds: this.state.packId,
          planId: planId,
          driverId: driver,
          carId: cartype
        }

        // alert(JSON.stringify(data))

        http
          .post(`${RETAIL.RETAIL_COMPANY_DELIVERYPACK_REASSGIN}`, data, {})
          .then((response) => {
            if (response.data.error == null) {
              message.success('عملیات با موفقیت انجام شد')
              this.setState({
                custommer: [],
                openTable: false,
                packId: []
              })
              http
                .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_RETURNED_ALL}?export=true&sortBy=geoTitle_ASC`, {})
                .then((response) => {
                  if (response.data.error == null) {
                    var points = response.data.object.result
                    for (let i = 0; i < points.length; i++) {
                      points[i]['checked'] = false
                      points[i]['geoTitle'] = points[i]['geo'].title
                    }
                    this.setState({
                      points: response.data.object.result,
                      masterPoints: response.data.object.result
                    })

                    var withOutPointArr = []

                    for (let j = 0; j < points.length; j++) {
                      if (this.state.points[j]['latitude'] == null) {
                        withOutPointArr.push(this.state.points[j])
                      }
                    }
                    this.setState({
                      withOutMarker: withOutPointArr
                    })
                  } else if (response.data.error == 'EMPTY_RESULTS') {
                    message.error('در این محدوده زمانی سفارشی موجود نیست')
                  }
                })
                .catch((error) => {
                  alert(JSON.stringify(error))
                })
            } else {
              this.setState({
                packId: []
              })
            }
          })
          .catch((error) => {
            alert(JSON.stringify(error))
          })
      }
    }
  }

  filterCars(e) {
    let {planId} = this.props.match.params
    var value = e.target.value
    if (value == 'even') {
      http
        .get(`car/manage/list`, {})
        .then((response) => {
          if (response.data.error == null) {
            let cars = response.data.object
            let evenCars = []
            for (let i = 0; i < cars.length; i++) {
              if (cars[i]['evenPlate']) {
                evenCars.push(cars[i])
              }
            }
            this.setState({
              cars: evenCars
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (value == 'odd') {
      http
        .get(`car/manage/list`, {})
        .then((response) => {
          if (response.data.error == null) {
            let cars = response.data.object
            let oddCars = []
            for (let i = 0; i < cars.length; i++) {
              if (!cars[i]['evenPlate']) {
                oddCars.push(cars[i])
              }
            }
            this.setState({
              cars: oddCars
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else if (value == 'pair') {
      http
        .get(`car/manage/list`, {})
        .then((response) => {
          if (response.data.error == null) {
            this.setState({
              cars: response.data.object
            })
          }
        })
        .catch((error) => {
          console.log(error)
        })
    } else {
      this.setState({
        cars: []
      })
    }
  }

  compareBy(key) {
    return function(a, b) {
      if (a[key] < b[key]) return -1
      if (a[key] > b[key]) return 1
      return 0
    }
  }

  sortBy(key) {
    let arrayCopy = this.state.points
    arrayCopy.sort(this.compareBy(key))
    this.setState({data: arrayCopy})
  }

  changeDriver(e) {
    let target = e.target
    this.setState({
      driverCarId: Number(target.options[target.selectedIndex].getAttribute('data-carid'))
    })
  }

  filter() {
    let {planId} = this.props.match.params
    let geoId = document.getElementById('geoId').value
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_UNASSIGNED}?planId=${planId}&geoId=${geoId}`, {})
      .then((response) => {
        if (response.data.error == null) {
          var points = response.data.object.result
          for (let i = 0; i < points.length; i++) {
            points[i]['checked'] = false
            points[i]['geoTitle'] = points[i]['geo'].title
          }

          this.setState({
            points: response.data.object.result
          })

          for (let i = 0; i < this.state.custommer.length; i++) {
            const positionObject = {
              deliveryPackId: this.state.custommer[i].deliveryPackId,
              invoiceId: this.state.custommer[i].invoiceId,
              invoiceNum: this.state.custommer[i].invoiceNum,
              totalAmount: this.state.custommer[i].totalAmount,
              payableAmount: this.state.custommer[i].payableAmount,
              address: this.state.custommer[i].address,
              buyerName: this.state.custommer[i].buyerName,
              checked: true
            }
            var index = this.state.points.findIndex((points) => points.deliveryPackId === positionObject.deliveryPackId)

            if (index >= 0) {
              this.setState((prevState) => {
                let newpoints = this.state.points
                newpoints[index].checked = positionObject.checked
                return {
                  points: newpoints
                }
              })
            }
          }
        } else {
          this.setState({
            points: []
          })
        }
      })
  }

  getMarkers() {
    let points = this.state.points
    const array = []
    points.forEach((item) => {
      if (item.latitude && item.longitude) {
        array.push({
          location: [item.latitude, item.longitude],
          ...item
        })
      }
    })
    return array
  }

  selectCustomer = (item, index) => {
    let positionObject = {
      deliveryPackId: item.deliveryPackId,
      invoiceId: item.invoiceId,
      invoiceNum: item.invoiceNum,
      totalAmount: item.totalAmount,
      payableAmount: item.payableAmount,
      address: item.address,
      geo: {
        title: item.geoTitle
      },
      buyerName: item.buyerName,
      checked: true
    }

    this.setState((prevState) => {
      let newpoints = this.state.points
      newpoints[index].checked = positionObject.checked
      return {
        points: newpoints
      }
    })
    const isFound = this.state.custommer.find((custommer) => custommer.deliveryPackId === positionObject.deliveryPackId)
    if (!isFound) {
      this.setState((prevState) => ({
        custommer: [...prevState.custommer, positionObject],
        openTable: true
      }))
    } else {
      message.error('این مشتری قبلا به لیست اضافه شده است')
    }
  }

  render() {
    const {points, selectedDateFrom, planOption} = this.state

    const unSelected = renderToStaticMarkup(<img src={require('../../image/requestPack.png')} />)
    const selected = renderToStaticMarkup(<img src={require('../../image/finishPack.png')} />)

    const classTable = this.state.openTable ? 'appointedCustommer' : 'appointedCustommer hide'

    var initialVal = 0
    var sumPrice = this.state.custommer.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    var initialVal = 0
    var sumUnassigned = this.state.points.reduce(function(acc, current) {
      return Number(acc) + Number(current.payableAmount)
    }, initialVal)

    return (
      <div className="rtl body">
        <div className="Packs wrapperIframe">
          <div className="titlePacks">
            <h5>لیست همه فاکتور ها</h5>
          </div>

          <div className="addressMap">
            <Map center={[35.6892, 51.389]} zoom={10} style={{height: '500px'}}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {this.getMarkers().map((item, index) => (
                <Marker
                  icon={
                    item.checked
                      ? divIcon({
                          html: selected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                      : divIcon({
                          html: unSelected,
                          iconSize: [30, 30],
                          iconAnchor: [10, 38]
                        })
                  }
                  position={item.location}
                  title={item.buyerName + '- شماره فاکتور : ' + item.invoiceNum}
                  onClick={() => this.selectCustomer(item, index)}
                />
              ))}
            </Map>
          </div>

          {/* <MapWithAMarker
            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDh3yzsorXDyP-gAlxEGUlzmfJ6nVxizUw&v=3.exp&libraries=geometry,drawing,places"
            loadingElement={<div style={{ height: `100%` }} />}
            containerElement={<div style={{ height: `400px` }} />}
            mapElement={<div style={{ height: `100%` }} />}
            onMarkerClick={this.handleMarkerClick}
            points={this.state.points}
          /> */}

          <div className="tableComponent" style={points.length == '0' ? {display: 'none'} : {display: 'block'}}>
            <table className="baseTable">
              <tr className="firstRow">
                <td>ردیف</td>
                <td>شناسه</td>
                <td onClick={() => this.sortBy('invoiceId')}>
                  شناسه فاکتور{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('invoiceNum')}>
                  شماره فاکتور{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('payableAmount')} className="priceCell">
                  {' '}
                  قابل پرداخت (ریال)
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td onClick={() => this.sortBy('geoTitle')}>
                  {' '}
                  منطقه{' '}
                  <span>
                    <img className="filterImage" src={require('../../image/filterTable.svg')} />{' '}
                  </span>
                </td>
                <td>آدرس</td>
                <td>موقعیت روی نقشه</td>
                <td>خریدار</td>
                <td>جزییات</td>
                <td>درج</td>
              </tr>
              {this.state.points.map((items, index) => (
                <tr style={items.checked ? {backgroundColor: '#efffae'} : {backgroundColor: '#fff'}}>
                  <td>{index + 1}</td>
                  <td>{items.deliveryPackId}</td>
                  <td>{items.invoiceId}</td>
                  <td>{items.invoiceNum}</td>
                  <td className="priceCell">{accounting.formatMoney(items.payableAmount, '', ',')}</td>
                  <td>{items.geo.title}</td>
                  <td>{items.address}</td>
                  <td>{items.latitude == null ? 'ندارد' : 'دارد'}</td>
                  <td>{items.buyerName}</td>
                  <td>
                    <Link to={`/subFactors/${items.deliveryPackId}`} target="_blank">
                      <img src={require('../../image/details.svg')} />
                    </Link>
                  </td>
                  <td>
                    <button
                      onClick={() => this.addCustomer({index})}
                      style={items.checked ? {display: 'none'} : {display: 'block'}}
                    >
                      <img src={require('../../image/add.svg')} />
                    </button>

                    <button
                      onClick={() => this.removeCustomer({index})}
                      style={items.checked ? {display: 'block'} : {display: 'none'}}
                    >
                      <img src={require('../../image/minus.svg')} />
                    </button>
                  </td>
                </tr>
              ))}
              <tr>
                <td colSpan={4}>مجموع</td>
                <td className="priceCell">{accounting.formatMoney(sumUnassigned, '', ',')}</td>
                <td colSpan={6} />
              </tr>
            </table>
          </div>
        </div>

        <div className="Packs wrapperIframe">
          <div className={classTable}>
            <div className="titlePacks">
              <h5>فاکتور های انتخاب شده</h5>
              <div className="btnMap">
                <button className="setPolygon btn btn-sm" onClick={this.Sort.bind(this)}>
                  مرتب سازی لیست
                </button>
                <button className="cancelPolygon btn btn-sm" onClick={this.deleteAllCustomer.bind(this)}>
                  حذف لیست
                </button>
              </div>
            </div>
            <div className="tableComponent">
              <table className="baseTable">
                <tr className="firstRow">
                  <td>ردیف</td>
                  <td>شناسه</td>
                  <td>شناسه فاکتور</td>
                  <td>شماره فاکتور</td>

                  <td className="priceCell"> قابل پرداخت (ریال)</td>
                  <td>منطقه</td>
                  <td>آدرس</td>
                  <td>نام خریدار</td>
                  <td>جزییات</td>
                  <td>بالا</td>
                  <td>پایین</td>
                  <td>حذف</td>
                </tr>
                {this.state.custommer.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{item.deliveryPackId}</td>
                    <td>{item.invoiceId}</td>
                    <td>{item.invoiceNum}</td>
                    <td className="priceCell">{accounting.formatMoney(item.payableAmount, '', ',')}</td>
                    <td>{item.geo.title}</td>
                    <td>{item.address}</td>
                    <td>{item.buyerName}</td>
                    <td>
                      <Link to={`/subFactors/${item.deliveryPackId}`} target="_blank">
                        <img src={require('../../image/details.svg')} />
                      </Link>
                    </td>
                    <td>
                      <button>
                        <img src={require('../../image/up.svg')} onClick={() => this.Up(index)} />
                      </button>
                    </td>
                    <td>
                      <button>
                        <img src={require('../../image/down.svg')} onClick={() => this.Down(index)} />
                      </button>
                    </td>
                    <td>
                      <button onClick={() => this.delete(index)}>
                        <img src={require('../../image/trash.svg')} />
                      </button>
                    </td>
                  </tr>
                ))}
                <tr>
                  <td colSpan={2}>مجموع قابل پرداخت</td>
                  <td colSpan={1} className="priceCell">
                    {accounting.formatMoney(sumPrice, '', ',') + ' ریال '}
                  </td>
                </tr>
              </table>
            </div>

            <form className="assignForm" onSubmit={this.submit.bind(this)}>
              <label>عملیات</label>
              <select className="form-control mb-2 mr-sm-2" onChange={this.changeAction.bind(this)} id="action">
                <option value="">------</option>
                <option value="marju">مرجوع</option>
                <option value="reAssign">تخصیص مجدد</option>
              </select>

              <div style={this.state.showForm ? {display: 'block'} : {display: 'none'}}>
                <label className="mb-2 mr-sm-2">نوع پلاک خودرو</label>
                <select className="form-control mb-2 mr-sm-2" onChange={this.filterCars.bind(this)}>
                  <option value="">-------</option>
                  <option value="even">زوج</option>
                  <option value="odd">فرد</option>
                  <option value="pair">زوج و فرد</option>
                </select>

                <label className="mb-2 mr-sm-2">رساننده</label>

                <select className="form-control mb-2 mr-sm-2" id="driver" onChange={this.changeDriver.bind(this)}>
                  <option value="">-------</option>
                  {this.state.drivers.map((driver, index) => (
                    <option data-carId={driver.carId} value={driver.personId}>
                      {driver.name}
                    </option>
                  ))}
                </select>

                <label className="mb-2 mr-sm-2">اتومبیل</label>
                <select className="form-control mb-2 mr-sm-2" id="carType">
                  <option value="">-------</option>
                  {this.state.cars.map((car, index) => (
                    <option selected={this.state.driverCarId == car.carId ? true : false} value={car.carId}>
                      {car.name + ' ' + car.plate + ' کد خودرو ' + car.code}
                    </option>
                  ))}
                </select>

                <label>تاریخ : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(selectedDateFrom) =>
                      selectedDateFrom == null ? '' : selectedDateFrom.format('jYYYY/jM/jDD')
                    }
                    onChange={this.handleDateChangeFrom}
                    TextFieldComponent={this.fromDate}
                    id="planDate"
                    name="planDate"
                    value={selectedDateFrom}
                    minDate={this.state.now}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
                <label>پلن : </label>
                <Select
                  value={planOption}
                  onChange={this.handleChangeplanOption}
                  options={this.state.allPlans}
                  isMulti={false}
                  isClearable={true}
                  placeholder=""
                />
              </div>

              <button className="btn btn-primary btn-sm" onClick={this.action.bind(this)}>
                اعمال
              </button>
              <p className="errorText">{this.state.assignError}</p>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export default Returned
